import { useEffect, useState } from "react";
import feedIntegrationFile from "./components/feedIntegration.md";

import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import ReactMarkdown from "react-markdown";

function FeedIntegration() {
  const [feedIntegrationData, setFeedIntegration] = useState("");

  useEffect(() => {
    fetch(feedIntegrationFile)
      .then((res) => res.text())
      .then((text) => setFeedIntegration(text));
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              {/* <SoftTypography variant="h5" fontWeight="medium">
                Live Feed Integration Documentation
              </SoftTypography> */}
              {/* <SoftTypography variant="button" fontWeight="regular" color="text">
                All tools you need to calibrate the feed you want to get is in this panel.
              </SoftTypography> */}
              <div className="code-holder">
                <ReactMarkdown>{feedIntegrationData}</ReactMarkdown>
              </div>
            </SoftBox>
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props for the DataTable
FeedIntegration.propTypes = {};

export default FeedIntegration;
